import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import OrdersFunnel from "./pages/OrdersFunnel";
import Overview from "./pages/Overview";
import SwiggyVsZomato from "./pages/SwiggyVsZomato";
import ZomatoOverview from "./pages/ZomatoOverview";
import Login from "./pages/Login";
import ProtectedRoute from './utils/ProtectedRoute'




function App() {
  


  return (
    <BrowserRouter>
        <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
          <Route path="/overview" element={<ProtectedRoute><Overview /> </ProtectedRoute>}/>
          <Route path="/orders" element={<ProtectedRoute><OrdersFunnel /> </ProtectedRoute>} />
          <Route path="/zomatoPerformance" element={<ProtectedRoute><ZomatoOverview /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><SwiggyVsZomato/> </ProtectedRoute>} />
           {/* <Route path="/funnel" element={<Funnel dataValue={data.funnel_metrics}/>} />  */}
           </Route>

           <Route path="/" element={<Navigate to="/login" />} />

        </Routes>
    </BrowserRouter>
  );
}

export default App;
